import { RankedPlayer } from "@twire/redux/playerRanking/types";

export const sortAndTrim = (
  data: RankedPlayer[],
  count: number
): RankedPlayer[] => {
  // const sort = data.sort((a, b) => (a.ranking > b.ranking ? 1 : -1));
  return data.slice(0, count);
};
